import { render, staticRenderFns } from "./home-view-canvas.vue?vue&type=template&id=7f997b6a&scoped=true&"
import script from "./home-view-canvas.vue?vue&type=script&lang=js&"
export * from "./home-view-canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f997b6a",
  null
  
)

export default component.exports